function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import * as React from "react";
import { Input } from "../../../helperComponents";
import CreateableSelect from "react-select/creatable";
import { carTypesOptions, heavyCarTypesOptions, carBrandsOptions, carDeducibleOptions } from "../data";
import { getYearsByRange } from "../data/car_years";
import Select from "react-select";

var LightVehicles = function LightVehicles(props) {
  var _onChange = props.onChange,
      _props$showHeavyVehic = props.showHeavyVehiclesType,
      showHeavyVehiclesType = _props$showHeavyVehic === void 0 ? false : _props$showHeavyVehic,
      itemAsegurado = props.itemAsegurado,
      index = props.index;
  var carYearsOption = getYearsByRange(1990, new Date().getFullYear() + 1);
  var typeSelectedOption = carTypesOptions.find(function (car_type) {
    return (itemAsegurado === null || itemAsegurado === void 0 ? void 0 : itemAsegurado.car_type) === car_type.value;
  });
  var brandSelectedOption = carBrandsOptions.find(function (brand) {
    return (itemAsegurado === null || itemAsegurado === void 0 ? void 0 : itemAsegurado.brand) === brand.value;
  });
  var deducibleSelectedOption = carDeducibleOptions.find(function (deducible) {
    return (itemAsegurado === null || itemAsegurado === void 0 ? void 0 : itemAsegurado.deducible) === parseInt(deducible.value);
  });
  var yearSelectedOption = carYearsOption.find(function (year) {
    return (itemAsegurado === null || itemAsegurado === void 0 ? void 0 : itemAsegurado.year) === year.value;
  });
  React.useEffect(function () {
    // Set default new patente if item_asegurado car is new.
    var defaultNewPatente = "ET0000";
    if (itemAsegurado !== null && itemAsegurado !== void 0 && itemAsegurado.is_new && (itemAsegurado === null || itemAsegurado === void 0 ? void 0 : itemAsegurado.patente) !== defaultNewPatente) _onChange && _onChange(_objectSpread(_objectSpread({}, itemAsegurado), {}, {
      patente: defaultNewPatente
    }));
  }, [itemAsegurado === null || itemAsegurado === void 0 ? void 0 : itemAsegurado.is_new]);
  return /*#__PURE__*/React.createElement("div", {
    className: "card-body cardBody cntRamo"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-3"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Tipo"), /*#__PURE__*/React.createElement(CreateableSelect, {
    options: showHeavyVehiclesType ? heavyCarTypesOptions : carTypesOptions,
    value: typeSelectedOption,
    className: "addMarginBottom",
    isSearchable: true,
    isClearable: true,
    placeholder: "Seleccione Tipo...",
    onChange: function onChange(item) {
      return _onChange && _onChange(_objectSpread(_objectSpread({}, itemAsegurado), {}, {
        car_type: item.value
      }));
    }
  }), /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Uso"), /*#__PURE__*/React.createElement("div", {
    className: "form-check form-check-inline usoOptions addMarginBottom"
  }, /*#__PURE__*/React.createElement("input", {
    className: "form-check-input",
    type: "radio",
    name: "".concat(index, "_use_checkbox"),
    id: "".concat(index, "_use_checkbox_id_1"),
    value: "particular",
    checked: (itemAsegurado === null || itemAsegurado === void 0 ? void 0 : itemAsegurado.use) === "particular",
    onChange: function onChange(e) {
      return _onChange && _onChange(_objectSpread(_objectSpread({}, itemAsegurado), {}, {
        use: e.currentTarget.value
      }));
    }
  }), " ", /*#__PURE__*/React.createElement("label", null, "Particular"), /*#__PURE__*/React.createElement("input", {
    className: "form-check-input",
    type: "radio",
    name: "".concat(index, "_use_checkbox"),
    id: "".concat(index, "_use_checkbox_id_2"),
    value: "comercial",
    checked: (itemAsegurado === null || itemAsegurado === void 0 ? void 0 : itemAsegurado.use) === "comercial",
    onChange: function onChange(e) {
      return _onChange && _onChange(_objectSpread(_objectSpread({}, itemAsegurado), {}, {
        use: e.currentTarget.value
      }));
    }
  }), " ", /*#__PURE__*/React.createElement("label", null, "Comercial"))), /*#__PURE__*/React.createElement("div", {
    className: "col-md-3"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Marca"), /*#__PURE__*/React.createElement(CreateableSelect, {
    options: carBrandsOptions,
    value: brandSelectedOption,
    className: "addMarginBottom",
    placeholder: "Seleccione Marca...",
    onChange: function onChange(item) {
      return _onChange && _onChange(_objectSpread(_objectSpread({}, itemAsegurado), {}, {
        brand: item.value
      }));
    }
  }), /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Deducible"), /*#__PURE__*/React.createElement(Select, {
    className: "addMarginBottom",
    options: carDeducibleOptions,
    value: deducibleSelectedOption,
    isSearchable: true,
    isClearable: true,
    placeholder: "Seleccione...",
    onChange: function onChange(item) {
      return _onChange && _onChange(_objectSpread(_objectSpread({}, itemAsegurado), {}, {
        deducible: parseInt(item.value)
      }));
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-md-3"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Modelo"), /*#__PURE__*/React.createElement(Input, {
    classNameInput: "form-control",
    className: "addMarginBottom",
    placeholder: "Escriba Modelo...",
    value: (itemAsegurado === null || itemAsegurado === void 0 ? void 0 : itemAsegurado.model) || "",
    onChange: function onChange(event) {
      return _onChange && _onChange(_objectSpread(_objectSpread({}, itemAsegurado), {}, {
        model: event.target.value
      }));
    }
  }), /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "\xBFVeh\xEDculo Nuevo?"), /*#__PURE__*/React.createElement("div", {
    className: "form-check form-check-inline usoOptions addMarginBottom"
  }, /*#__PURE__*/React.createElement("input", {
    className: "form-check-input",
    type: "radio",
    name: "".concat(index, "_is_new_checkbox"),
    id: "inlineRadio1",
    checked: (itemAsegurado === null || itemAsegurado === void 0 ? void 0 : itemAsegurado.is_new) === true,
    onChange: function onChange() {
      return _onChange && _onChange(_objectSpread(_objectSpread({}, itemAsegurado), {}, {
        is_new: true
      }));
    }
  }), " ", /*#__PURE__*/React.createElement("label", null, "Si"), /*#__PURE__*/React.createElement("input", {
    className: "form-check-input",
    type: "radio",
    name: "".concat(index, "_is_new_checkbox"),
    id: "inlineRadio2",
    checked: (itemAsegurado === null || itemAsegurado === void 0 ? void 0 : itemAsegurado.is_new) === false,
    onChange: function onChange() {
      return _onChange && _onChange(_objectSpread(_objectSpread({}, itemAsegurado), {}, {
        is_new: false
      }));
    }
  }), " ", /*#__PURE__*/React.createElement("label", null, "No"))), /*#__PURE__*/React.createElement("div", {
    className: "col-md-3"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "A\xF1o"), /*#__PURE__*/React.createElement(Select, {
    options: carYearsOption,
    value: yearSelectedOption,
    className: "addMarginBottom",
    isSearchable: true,
    isClearable: true,
    placeholder: "Seleccione Año...",
    onChange: function onChange(item) {
      return _onChange && _onChange(_objectSpread(_objectSpread({}, itemAsegurado), {}, {
        year: item.value
      }));
    }
  }), /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Patente"), /*#__PURE__*/React.createElement(Input, {
    classNameInput: "form-control",
    placeholder: "Escriba Patente...",
    value: (itemAsegurado === null || itemAsegurado === void 0 ? void 0 : itemAsegurado.patente) || "",
    maxLength: 6,
    onChange: function onChange(event) {
      return _onChange && _onChange(_objectSpread(_objectSpread({}, itemAsegurado), {}, {
        patente: event.target.value.toLocaleUpperCase()
      }));
    }
  })));
};

export default LightVehicles;